<template>
  <p class="price">
    <br />
    — <slot /> gold —
  </p>
</template>

<style lang="sass">
.price
  font-size: 80%
</style>
